import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { adminLogin, adminMe, setToken, clearToken, getToken } from "@/lib/adminApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth, object = auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      setReady(true);
      return;
    }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => {
        clearToken();
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await adminLogin(email, password);
    setToken(res.token);
    setUser(res.user);
    return res;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
